import React from "react";

const TZ = "Europe/London";
export const fmtSlot = (iso) => new Date(iso).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: TZ });

// Tiny renderer: paragraphs, "- " bullets and **bold** only
const inline = (t) => t.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : p));

export const ChatText = ({ text }) => {
  const blocks = text.split(/\n{2,}/);
  return blocks.map((b, i) => {
    const lines = b.split("\n").filter(Boolean);
    if (lines.length && lines.every((l) => /^\s*[-•]\s/.test(l))) {
      return <ul key={i} className="list-disc pl-5 space-y-0.5">{lines.map((l, j) => <li key={j}>{inline(l.replace(/^\s*[-•]\s/, ""))}</li>)}</ul>;
    }
    return <p key={i}>{lines.map((l, j) => <React.Fragment key={j}>{j > 0 && <br />}{inline(l)}</React.Fragment>)}</p>;
  });
};

export const TimeChoices = ({ data, onPick, idx }) => {
  if (!data.slots.length) {
    return <p className="text-xs text-ink-muted" data-testid={`chat-times-empty-${idx}`}>{data.error || "No times are open for that yet - please check the booking page or email the clinic."}</p>;
  }
  return (
    <div data-testid={`chat-times-${idx}`} className="mt-1">
      <div className="text-xs text-ink-muted mb-1.5">{data.consultant_name ? `${data.consultant_name} · ` : ""}tap a time (when to arrive):</div>
      <div className="flex flex-wrap gap-1.5">
        {data.slots.map((s) => (
          <button key={s} type="button" onClick={() => onPick({ ...data, slot: s })} data-testid={`chat-time-${s}`}
            className="px-2.5 py-1.5 text-xs rounded-md border border-bronze-light/60 bg-white hover:bg-cream-100 transition-colors">
            {fmtSlot(s)}
          </button>
        ))}
      </div>
    </div>
  );
};
